<div class="footer-section">
  <div class="container-fluid">
    <div class="row">
      <div class="text-right ml-auto mr-auto copyright">
        Copyright © 2020 Harris Poll. All rights reserved.
      </div>
    </div>
  </div>
</div>